export function randomId() {
    if (typeof crypto !== "undefined" && "randomUUID" in crypto) return crypto.randomUUID()
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
        const value = (Math.random() * 16) | 0
        return (char === "x" ? value : (value & 3) | 8).toString(16)
    })
}

export function randomToken() {
    if (typeof crypto === "undefined") return randomId().replaceAll("-", "") + randomId().replaceAll("-", "")
    const bytes = new Uint8Array(32)
    crypto.getRandomValues(bytes)
    return btoa(String.fromCharCode(...bytes)).replaceAll("+", "-").replaceAll("/", "_").replaceAll("=", "")
}
